(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ifshe-announcements')) {
    class IfsheAnnouncements extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ifshe-ann__slide'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.speed = Math.max(3, parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.hovering = false;
        this.querySelector('[data-ifshe-ann-prev]')?.addEventListener('click', () => this.step(-1, true));
        this.querySelector('[data-ifshe-ann-next]')?.addEventListener('click', () => this.step(1, true));
        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.stop();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.start();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.start();
        });
        this.addEventListener(
          'touchstart',
          () => {
            this.stop();
            clearTimeout(this.resumeTimer);
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          () => {
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(() => this.start(), this.speed);
          },
          { passive: true }
        );
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        if (this.reduced.addEventListener) {
          this.reduced.addEventListener('change', () => (this.reduced.matches ? this.stop() : this.start()));
        }
        this.start();
      }

      get autoplay() {
        return this.dataset.autoplay === 'true' && !this.reduced.matches && !this.paused;
      }

      start() {
        this.stop();
        if (!this.autoplay || this.hovering || document.hidden) return;
        this.timer = setInterval(() => this.step(1, false), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      step(dir, byUser) {
        if (byUser) this.paused = true; // 手动翻过就不再自动轮播
        this.show((this.index + dir + this.slides.length) % this.slides.length);
      }

      show(i) {
        this.slides.forEach((slide, k) => {
          const on = k === i;
          slide.classList.toggle('is-active', on);
          if (on) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.index = i;
      }
    }
    customElements.define('ifshe-announcements', IfsheAnnouncements);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.header.querySelectorAll('ifshe-mega-menu').forEach((menu) => menu.closeAll && menu.closeAll());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // IfShe 带图大菜单：一级项本身是链接；鼠标悬停（带意图延时）或点旁边的展开按钮打开面板。
  // 触屏不走悬停，点展开按钮；Esc 关闭并把焦点还给按钮；焦点移出该项即关闭。
  class IfsheMegaMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-ifshe-mega]'));
      this.sticky = this.closest('sticky-header');
      this.current = null;
      this.items.forEach((item) => {
        const toggle = item.querySelector('[data-ifshe-mega-toggle]');
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.schedule(item, true);
        });
        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.schedule(item, false);
        });
        if (toggle) {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            clearTimeout(this.timer);
            this.current === item ? this.close(item) : this.open(item);
          });
        }
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.close(item);
        });
        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || this.current !== item) return;
          this.close(item);
          if (toggle) toggle.focus();
        });
      });
      const warm = () => this.warm();
      this.addEventListener('pointerenter', warm, { once: true });
      this.addEventListener('focusin', warm, { once: true });
      this.onDocClick = (event) => {
        if (this.current && !this.contains(event.target)) this.closeAll();
      };
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }

    // 第一次碰到导航就预取面板图（面板关着时图片 display:none 不会加载）
    warm() {
      if (this.warmed) return;
      this.warmed = true;
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    }

    schedule(item, open) {
      clearTimeout(this.timer);
      const delay = open ? (this.current ? 40 : 110) : 180;
      this.timer = setTimeout(() => (open ? this.open(item) : this.close(item)), delay);
    }

    open(item) {
      if (this.current === item) return;
      const switching = Boolean(this.current);
      if (this.current) this.close(this.current, true);
      this.classList.toggle('is-switching', switching);
      item.setAttribute('data-open', '');
      const toggle = item.querySelector('[data-ifshe-mega-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      this.current = item;
      this.classList.add('is-open');
      if (this.sticky) this.sticky.preventHide = true;
      this.warm();
    }

    close(item, switching = false) {
      item.removeAttribute('data-open');
      const toggle = item.querySelector('[data-ifshe-mega-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (this.current === item) this.current = null;
      if (!switching) {
        this.classList.remove('is-open', 'is-switching');
        if (this.sticky) this.sticky.preventHide = false;
      }
    }

    closeAll() {
      clearTimeout(this.timer);
      this.items.forEach((item) => this.close(item));
    }
  }

  if (!customElements.get('ifshe-mega-menu')) customElements.define('ifshe-mega-menu', IfsheMegaMenu);

  } catch(e) { console.error(e); }
})();
})();
